<template>
    <div id="app" class="theme_white">
        <router-view />
    </div>
</template>
<script>
    // 设置html标签字体大小
    ;(function (ratio) {

        var sreen_info = (function () {
            var el = document.createElement('div');
            var st = el.style;

            st.width = '1in';
            st.left = '-100%';
            st.position = 'absolute';

            return function () {
                document.body.appendChild(el);

                var devicePixelRatio = window.devicePixelRatio || 1;
                var dpi = el.offsetWidth * devicePixelRatio;

                document.body.removeChild(el);

                return {
                    dpi: dpi,
                    ratio: devicePixelRatio
                };
            }
        })();

        var st = document.documentElement.style;

        function update() {
            var info = sreen_info();
            var size = info.dpi / 25.4; // 每毫米像素点数
            st.fontSize = size * ratio / info.ratio + 'px';
        }

        update();

        window.addEventListener('load', update);
        window.addEventListener('resize', update);

    })(3.4);
    
    export default {
        
    }
</script>
<style src="@/assets/css/main.css"></style>
<style>

    #app {
        font-family: Avenir, -apple-system-font, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #fff;
        background-color: #2E2E2E;
        height: 100%;
        position: relative;
    }

    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    p,
    ul,
    li {
        margin: 0;
        padding: 0;
    }

    ul {
        list-style: none;
    }
</style>